"use client";

import { Button } from "@/components/ui/button";
import { GraduationCap, LogOut, Lock, Users, BarChart3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/global-hooks/useAuth";
import { ChangePasswordModal } from "@/components/change-password-modal";
import { ModeToggle } from "@/components/mode-toggle";
import { useState } from "react";

export default function DashboardHeader() {
	const navigate = useNavigate();
	const auth = useAuth();
	const [showChangePassword, setShowChangePassword] = useState(false);

	// `logout` reloads onto the login page itself, so there is nothing to
	// navigate to here.
	const handleSignOut = () => auth.logout();

	const handleReturnToDashboard = () => {
		navigate("/dashboard");
	};

	return (
		<>
			<header className="bg-card border-b border-border print:hidden">
				<div className="container mx-auto px-3 py-3 sm:px-4 sm:py-4">
					{/* Wraps below the title on narrow screens: the action row is ~680px
						wide and would otherwise push the page into horizontal scroll. */}
					<div className="flex flex-wrap items-center justify-between gap-y-3">
						<div
							className="flex items-center gap-2 sm:gap-3 cursor-pointer hover:opacity-80 transition-opacity"
							onClick={handleReturnToDashboard}
						>
							<GraduationCap className="h-7 w-7 sm:h-8 sm:w-8 text-blue-600 dark:text-blue-400 flex-shrink-0" />
							<div>
								<h1 className="text-base sm:text-lg md:text-xl font-bold text-foreground">
									Cổng Thông Tin Giấy Báo Trúng Tuyển
								</h1>
							</div>
						</div>

						{/* Dưới sm hàng hành động chiếm trọn bề ngang và căn trái: căn phải trên
						    máy hẹp làm các nút xuống dòng lệch nhau, mỗi dòng một mép khác nhau. */}
						<div className="flex w-full flex-wrap items-center justify-start gap-2 sm:w-auto sm:justify-end sm:gap-3">
							<div className="text-left sm:text-right">
								<p className="text-sm font-medium text-foreground">{auth.user?.name}</p>
								<p className="text-sm text-muted-foreground">{auth.user?.MaCB}</p>
							</div>

							<ModeToggle />

							{(auth.user?.role === "admin" || auth.user?.role === "manager") && (
								<Button
									onClick={() => navigate("/statistics")}
									variant="outline"
									size="sm"
									className="flex items-center gap-2 bg-transparent"
								>
									<BarChart3 className="h-4 w-4" />
									Thống kê
								</Button>
							)}

							{auth.user?.role === "admin" && (
								<Button
									onClick={() => navigate("/admin")}
									variant="outline"
									size="sm"
									className="flex items-center gap-2 bg-transparent"
								>
									<Users className="h-4 w-4" />
									Công cụ quản trị
								</Button>
							)}

							<Button
								onClick={() => setShowChangePassword(true)}
								variant="outline"
								size="sm"
								className="flex items-center gap-2 bg-transparent"
							>
								<Lock className="h-4 w-4" />
								Đổi mật khẩu
							</Button>

							<Button
								onClick={handleSignOut}
								variant="outline"
								size="sm"
								className="flex items-center gap-2 bg-transparent"
							>
								<LogOut className="h-4 w-4" />
								Đăng xuất
							</Button>
						</div>
					</div>
				</div>
			</header>

			<ChangePasswordModal
				isOpen={showChangePassword}
				onClose={() => setShowChangePassword(false)}
			/>
		</>
	);
}
